<template>
  <div>
    <!-- 加载遮罩 -->
    <div v-if="!url" class="loading-mask-container">
      <div class="loading-icon-wrapper">
        <img src="/static/image/rotate.963673.png" alt="" class="loading-rotate-img" />
      </div>
    </div>

    <!-- iframe 页面 -->
    <div v-else class="iframe-container">
      <iframe ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
    };
  },
  created() {
    this.$apiFun.post('/api/getservicerurl', {}).then(res => {
      if (res.code != 200) {
        this.showTost(0, res.message);
      } else {
        this.url = res.data.url;
      }
    });
  },
  updated() {
    if (this.url && this.$refs.iframe) {
      this.$refs.iframe.contentWindow.location.replace(this.url);
    }
  },
};
</script>

<style lang="scss" scoped>
/* 白色 loading 遮罩 */
.loading-mask-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff; /* 白色背景 */
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-icon-wrapper {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-rotate-img {
  width: 60px;
  height: 60px;
}

/* iframe 容器白色背景 */
.iframe-container {
  height: calc(100vh - 50px);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background: #fff; /* 白色背景 */
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
  background: #fff; /* iframe 背景也白色 */
}
</style>



// WEBPACK FOOTER //
// src/components/main/kefu.vue